import { withInstall } from '@vuesax-plus/utils'

import Rate from './src/rate.vue'

export const VsRate = withInstall(Rate)
export default VsRate

export * from './src/rate'
